import Image from 'next/image';
import { useTheme } from 'styled-components';

import { HeaderForm } from '~/components/Header/HeaderForm';
import {
  HeaderFrontImageDesktop,
  HeaderFrontImageTablet,
  HeaderTitle,
  StyledHeader,
  StyledHeaderContainer,
  StyledHeaderMainContainer,
  StyledHeaderTitleContainer,
} from '~/components/Header/styles';
import { sanitize } from '~/utils/sanitize';
import type { SearchParams } from '~/utils/search/types';

type HeaderProps = Pick<SearchParams, 'job' | 'address'> & {
  isSearchApplied?: boolean;
  hideSearch?: boolean;
  hideImage?: boolean;
  title: string;
};

export const Header = ({ isSearchApplied, hideSearch, hideImage, title }: HeaderProps) => {
  const { devices } = useTheme();

  // the page's largest paint on desktop: fetched first, at the width it is displayed. Hidden on mobile and laptop
  // widths (see the styles), where the preload resolves to the smallest candidate rather than 52 KB nobody sees
  const image = (
    <Image
      alt=""
      preload
      fetchPriority="high"
      src="/images/picture-job-board.png"
      width={372}
      height={450}
      sizes={`(max-width: ${devices.mobile.max}) 1px, (max-width: ${devices.tablet.max}) 300px, (max-width: ${devices.laptop.max}) 1px, 350px`}
    />
  );

  return (
    <StyledHeader>
      <StyledHeaderMainContainer>
        <StyledHeaderContainer>
          <StyledHeaderTitleContainer>
            <HeaderTitle variant="heading-1" dangerouslySetInnerHTML={{ __html: sanitize(title) }} />
            {!hideImage && <HeaderFrontImageTablet>{image}</HeaderFrontImageTablet>}
          </StyledHeaderTitleContainer>
          {!hideSearch && <HeaderForm isSearchApplied={isSearchApplied} />}
        </StyledHeaderContainer>
        {!hideImage && <HeaderFrontImageDesktop>{image}</HeaderFrontImageDesktop>}
      </StyledHeaderMainContainer>
    </StyledHeader>
  );
};
